function mapLatLongFilter() {
    'ngInject';

    return (address) => {
        if (!address) {
            return;
        }
        if (!address.map_url) {
            return;
        }

        const cord = /([-+]*\d{1,3}[\.]\d*)[, ]([-+]*\d{1,3}[\.]\d*)/.exec(address.map_url);
        return cord[0];
    };
}

angular
    .module('BB')
    .filter('map_lat_long', mapLatLongFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/map_lat_long.filter.js